import { LayoutUnitTypeEnum } from "./LayoutUnitType";

export interface LayoutUnitProps {
  type?: LayoutUnitTypeEnum;
}
export class LayoutUnit {
  type?: LayoutUnitTypeEnum;

  static create(props: LayoutUnitProps) {
    const newUnit = new LayoutUnit();
    newUnit.type = props.type;

    return newUnit;
  }

  get isUnassigned() {
    return this.type === undefined;
  }

  public sameTo(otherProps: LayoutUnitProps) {
    return this.type === otherProps.type;
  }
}
